import React from "react";
import NextLink from "next/link";

export default function Link({ href, children, ...props }) {
  let convertedHref = href;
  let external = false;

  if (href.includes(process.env.NEXT_PUBLIC_WEBSITE_URL)) {
    convertedHref = href.replace(process.env.NEXT_PUBLIC_WEBSITE_URL, "");
  } else {
    if (href.includes("http:")) {
      external = true;
    }
  }

  return (
    <NextLink
      href={convertedHref}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      {...props}
    >
      {children}
    </NextLink>
  );
}
